import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { premiumBenefitsContent, premiumBenefitsIconSwap, token, tokenPopulated } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n<div class=\"campaign-properties-section\">\r\n</div>\r\n\r\n<div id=\"network-benefits-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":11,"column":45},"end":{"line":11,"column":59}}}))
    + "\"></div>\r\n\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"ENABLE_NETWORK_BENEFITS") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":33,"column":7}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row show-for-medium-up\">\r\n  <div class=\"column small-12\">\r\n    <h2 data-font=\"cnx-light\" tabindex=\"0\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"LABEL_NETWORK_BENEFITS") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"column small-12 medium-10 medium-offset-1 large-12 large-offset-0 benefits-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"benefits") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":30,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"tokenPopulated")||(depth0 && lookupProperty(depth0,"tokenPopulated"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,(depths[1] != null ? lookupProperty(depths[1],"campaignProperties") : depths[1]),{"name":"tokenPopulated","hash":{},"data":data,"loc":{"start":{"line":15,"column":10},"end":{"line":15,"column":53}}}),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":4},"end":{"line":29,"column":11}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"premiumBenefitsContent")||(depth0 && lookupProperty(depth0,"premiumBenefitsContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"token")||(depth0 && lookupProperty(depth0,"token"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,(depths[1] != null ? lookupProperty(depths[1],"campaignProperties") : depths[1]),{"name":"token","hash":{},"data":data,"loc":{"start":{"line":16,"column":30},"end":{"line":16,"column":64}}}),(depths[1] != null ? lookupProperty(depths[1],"campaignProperties") : depths[1]),{"name":"premiumBenefitsContent","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":28,"column":31}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"benefit\">\r\n      <div class=\"benefit-container\">\r\n        <div class=\"image-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"content"))) && lookupProperty(stack1,"icons")),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":10},"end":{"line":22,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n        <h3>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"NETWORK_BENEFITS_HEADER_XX") || (depth0 != null ? lookupProperty(depth0,"NETWORK_BENEFITS_HEADER_XX") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"NETWORK_BENEFITS_HEADER_XX","hash":{},"data":data,"loc":{"start":{"line":24,"column":12},"end":{"line":24,"column":44}}}) : helper))) != null ? stack1 : "")
    + "</h3>\r\n        <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"NETWORK_BENEFITS_CONTENT_XX") || (depth0 != null ? lookupProperty(depth0,"NETWORK_BENEFITS_CONTENT_XX") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"NETWORK_BENEFITS_CONTENT_XX","hash":{},"data":data,"loc":{"start":{"line":25,"column":11},"end":{"line":25,"column":44}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n      </div>\r\n    </div>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + container.escapeExpression((lookupProperty(helpers,"premiumBenefitsIconSwap")||(depth0 && lookupProperty(depth0,"premiumBenefitsIconSwap"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depths[1],(lookupProperty(helpers,"token")||(depth0 && lookupProperty(depth0,"token"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"token","hash":{},"data":data,"loc":{"start":{"line":21,"column":40},"end":{"line":21,"column":52}}}),(lookupProperty(helpers,"token")||(depth0 && lookupProperty(depth0,"token"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"token","hash":{},"data":data,"loc":{"start":{"line":21,"column":53},"end":{"line":21,"column":65}}}),{"name":"premiumBenefitsIconSwap","hash":{},"data":data,"loc":{"start":{"line":21,"column":12},"end":{"line":21,"column":67}}}))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":34,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/network-benefits-cc-module",
  "version": "6.0.3",
  "id": "networkBenefitsCcModule",
  "containerID": "creditCardsNetworkBenefitsCcModule",
  "moduleName": "credit-cards-network-benefits-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "network-benefits-cc-module",
  "data": {
    "init": "networkBenefitsCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "noActiveIcon",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Disables check for active/inactive icon in helper"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        json,
        premiumBenefitsContent,
        premiumBenefitsIconSwap,
        token,
        tokenPopulated
      },
      "partials": {
        "network-benefits-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "network-benefits-cc-partial": renderTemplate
  },
  "helpers": {
    json,
    premiumBenefitsContent,
    premiumBenefitsIconSwap,
    token,
    tokenPopulated
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/* global spaParams sparta */

/*
 * network-benefits-cc-module
 * module_js_id: networkBenefitsCcModuleJS
 *
 * Copyright (c) 2017-12-4 removed
 */

/**
 * @export
 * @class networkBenefitsCcModuleJS
 * @extends {Module}
 */
class networkBenefitsCcModuleJS extends Module {
  /**
   * Creates an instance of networkBenefitsCcModuleJS.
   * @param {*} options - options object
   * @param {*} context - context object
   * @memberof networkBenefitsCcModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.target = this.settings.target;
    this.content = JSON.parse(this.target.querySelector('#network-benefits-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['network-benefits-cc-partial'];
    const magellanDest = this.target.dataset.init.substr(0, this.target.dataset.init.length - 2);
    this.target.dataset.magellanDestination = magellanDest;
  }

  /**
   * Initialize the module
   * @memberof networkBenefitsCcModuleJS
   * @returns {void}
   */
  init() {
    this.Events.sub('campaignProperties-spartaStore', data => {
      let campaignProperties = data.data.data;
      if (this.params.noActiveIcon) {
        /* This will be removed once LoB solidifies PCM data.
          NOTE: credit-card-utility 4.0.0 & credit-card-helper 4.0.0
          were already created, but caused a cascade of dependency issues.
          - 4.0.1 can be used for the next updates for this work.
        */
        campaignProperties = {
          ...campaignProperties,
          NETWORK_BENEFITS_ACTIVE_ICON_01: '/content/images/ContextualSiteGraphics/Instructional/en_US/creditcards/network-benefits-icons/luggage_red_rgb.svg',
          NETWORK_BENEFITS_ACTIVE_ICON_02: '/content/images/ContextualSiteGraphics/Instructional/en_US/creditcards/network-benefits-icons/purchaseprotection_active.svg',
          NETWORK_BENEFITS_ACTIVE_ICON_03: '/content/images/ContextualSiteGraphics/Instructional/en_US/creditcards/network-benefits-icons/purchaseprotection_active.svg',
          NETWORK_BENEFITS_ACTIVE_ICON_04: '/content/images/ContextualSiteGraphics/Instructional/en_US/creditcards/network-benefits-icons/tickets_red_rgb.svg',
          NETWORK_BENEFITS_ACTIVE_ICON_05: '/content/images/ContextualSiteGraphics/Instructional/en_US/creditcards/network-benefits-icons/luggage_red_rgb.svg'
        };
      }
      const campaign = this.Store.getData('campaign');
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        site: spaParams.siteParams,
        params: this.params,
        content: linkContent,
        sparta
      });
      this.target.querySelector('.campaign-properties-section').innerHTML = renderedTemplate;
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });

      /** ADA fix :-
      * To convey the user for links that opens in a new window/tab
      */
      [...this.target.querySelectorAll("a[target='_blank']")].forEach(link => {
        if (link.innerText === this.content.betterMoneyHabits.text) {
          link.insertAdjacentHTML('beforeend', this.content.betterMoneyHabits.adaText);
        }
      });
    });
  }
}
registerModuleClass({
  moduleClass: networkBenefitsCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { networkBenefitsCcModuleJS as default, moduleConfig };
